<template>
  <div class="pending-offer">
    <div class="row">
      <div class="col-3 pending-offer-logo"><img :src="logoURL" v-if="logoURL" /></div>
      <div class="col-7 pending-offer-title">{{title}}</div>
      <div class="col-2 loading">
        <img :src="loadingImg" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PendingOffer',
  props: ['offer'],
  components: {
  },
  data () {
    return {
      loadingImg: process.env.BASE_URL + 'loading.gif'
    }
  },
  computed: {
    logoURL () {
      return this.offer.logoURL
    },
    title () {
      return this.offer.name
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.pending-offer {
  padding-top: 10px;
}
.pending-offer-logo img {
  max-width: 100%;
  max-height: 45px;
  width: auto;
  height: auto;
}
.loading img {
  height: 18px;
  margin-top: -2px;
  float: right;
}
</style>
